"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twoSideLayout = zebra.Class(zebra.layout.PercentLayout, [
    function (leftSideWidth, dir, gap, stretch) {
        this._leftSideWidth = leftSideWidth;
        var alternativeGapWidth = 2;
        dir = dir || zebra.layout.HORIZONTAL;
        gap = gap || alternativeGapWidth;
        stretch = stretch || true;
        this.$super(dir, gap, stretch);
    },
    function setGap(gap) {
        this.gap = gap;
    },
    function doLayout(target) {
        var kidsCount = target.kids.length;
        var requiredKidsCount = 2;
        if (kidsCount !== requiredKidsCount) {
            throw new Error("ERROR! The twoSideLayout requires, that the target item has 2 kids. The current target has " + kidsCount + " kids!");
        }
        var right = target.getRight();
        var top = target.getTop();
        var bottom = target.getBottom();
        var left = target.getLeft();
        for (var i = 0; i < kidsCount; i++) {
            var kid = target.kids[i];
            if (this.direction === zebra.layout.HORIZONTAL) {
                var rightSideWidth = target.width - this._leftSideWidth;
                var hh = target.height - top - bottom;
                if (i === 0) {
                    kid.setLocation(left, top);
                    kid.setSize(this._leftSideWidth, hh);
                }
                else {
                    kid.setLocation(this._leftSideWidth + this.gap, top);
                    kid.setSize(rightSideWidth, hh);
                }
            }
            else {
                var topSideHeight = this._leftSideWidth;
                var bottomSideHeight = target.height - this._leftSideWidth;
                var ww = target.width - left - right;
                if (i === 0) {
                    kid.setLocation(left, top);
                    kid.setSize(ww, topSideHeight);
                }
                else {
                    kid.setLocation(left, topSideHeight + this.gap);
                    kid.setSize(ww, bottomSideHeight);
                }
            }
        }
    }
]);
//# sourceMappingURL=twoSideLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/layouts/twoSideLayout.js
// module id = 82
// module chunks = 0